// AUTO-GENERATED by scripts/gen-colormaps.mjs — DO NOT EDIT BY HAND.
//
// Source: PlotPy plotpy/data/colormaps_default.json
// Regenerate with: node scripts/gen-colormaps.mjs [path/to/json]
//
// Each colormap is a list of stops [position(0..1), r, g, b] with r/g/b in
// 0..255. Smooth maps are simplified (collinear stops removed); qualitative
// maps keep their hard transitions (duplicated positions).

/** One colormap stop: [position (0..1), r, g, b] (channels 0..255). */
export type ColormapStop = readonly [number, number, number, number];

/** Ordered list of stops defining a colormap. */
export type ColormapStops = readonly ColormapStop[];

/** Raw stop definitions for every default colormap, keyed by lowercase name. */
export const COLORMAP_STOPS: Readonly<Record<string, ColormapStops>> = {
  viridis: [
    [0, 68, 1, 84],
    [0.078431, 72, 29, 111],
    [0.137255, 70, 48, 126],
    [0.219608, 62, 73, 137],
    [0.345098, 47, 107, 142],
    [0.498039, 33, 144, 141],
    [0.560784, 31, 159, 136],
    [0.603922, 35, 169, 131],
    [0.65098, 47, 180, 124],
    [0.709804, 72, 193, 110],
    [0.776471, 108, 205, 90],
    [0.866667, 165, 219, 54],
    [0.92549, 205, 225, 29],
    [0.952941, 223, 227, 24],
    [0.984314, 244, 230, 30],
    [1, 253, 231, 37],
  ],
  plasma: [
    [0, 13, 8, 135],
    [0.027451, 32, 6, 143],
    [0.109804, 70, 3, 159],
    [0.196078, 105, 0, 168],
    [0.25098, 126, 3, 168],
    [0.309804, 148, 16, 162],
    [0.403922, 178, 43, 143],
    [0.541176, 213, 83, 111],
    [0.678431, 239, 124, 81],
    [0.784314, 251, 161, 57],
    [0.866667, 254, 192, 41],
    [0.92549, 250, 216, 36],
    [0.984314, 242, 242, 39],
    [1, 240, 249, 33],
  ],
  inferno: [
    [0, 0, 0, 4],
    [0.031373, 4, 3, 18],
    [0.086275, 18, 10, 50],
    [0.137255, 38, 12, 81],
    [0.176471, 56, 9, 98],
    [0.227451, 77, 13, 108],
    [0.317647, 114, 26, 110],
    [0.403922, 149, 38, 103],
    [0.494118, 185, 53, 86],
    [0.592157, 218, 78, 60],
    [0.67451, 239, 108, 35],
    [0.74902, 249, 140, 10],
    [0.776471, 251, 153, 6],
    [0.8, 252, 165, 10],
    [0.839216, 251, 184, 29],
    [0.886275, 248, 207, 58],
    [0.929412, 243, 229, 93],
    [0.960784, 242, 242, 125],
    [0.984314, 246, 250, 150],
    [1, 252, 255, 164],
  ],
  magma: [
    [0, 0, 0, 4],
    [0.027451, 3, 3, 15],
    [0.078431, 14, 11, 43],
    [0.137255, 33, 17, 78],
    [0.188235, 54, 16, 107],
    [0.227451, 71, 16, 120],
    [0.294118, 98, 25, 128],
    [0.407843, 144, 42, 129],
    [0.505882, 184, 55, 121],
    [0.6, 222, 73, 104],
    [0.658824, 239, 93, 94],
    [0.713725, 248, 118, 92],
    [0.768627, 252, 144, 101],
    [0.835294, 254, 176, 120],
    [0.929412, 253, 220, 158],
    [1, 252, 253, 191],
  ],
  cividis: [
    [0, 0, 34, 78],
    [0.078431, 0, 48, 112],
    [0.090196, 1, 50, 113],
    [0.113725, 20, 54, 112],
    [0.152941, 38, 61, 110],
    [0.235294, 63, 76, 108],
    [0.360784, 94, 98, 110],
    [0.509804, 126, 125, 120],
    [0.619608, 153, 146, 119],
    [0.74902, 187, 173, 109],
    [0.85098, 214, 195, 93],
    [0.917647, 233, 211, 78],
    [0.972549, 249, 224, 58],
    [0.988235, 254, 228, 52],
    [1, 254, 232, 56],
  ],
  greys: [
    [0, 255, 255, 255],
    [0.125, 240, 240, 240],
    [0.25, 217, 217, 217],
    [0.375, 189, 189, 189],
    [0.5, 150, 150, 150],
    [0.75, 82, 82, 82],
    [0.875, 37, 37, 37],
    [1, 0, 0, 0],
  ],
  purples: [
    [0, 252, 251, 253],
    [0.125, 239, 237, 245],
    [0.25, 218, 218, 235],
    [0.375, 188, 189, 220],
    [0.5, 158, 154, 200],
    [0.625, 128, 125, 186],
    [0.875, 84, 39, 143],
    [1, 63, 0, 125],
  ],
  blues: [
    [0, 247, 251, 255],
    [0.25, 198, 219, 239],
    [0.375, 158, 202, 225],
    [0.5, 107, 174, 214],
    [0.625, 66, 146, 198],
    [0.75, 33, 113, 181],
    [0.875, 8, 81, 156],
    [1, 8, 48, 107],
  ],
  greens: [
    [0, 247, 252, 245],
    [0.125, 229, 245, 224],
    [0.25, 199, 233, 192],
    [0.375, 161, 217, 155],
    [0.5, 116, 196, 118],
    [0.625, 65, 171, 93],
    [0.75, 35, 139, 69],
    [0.875, 0, 109, 44],
    [1, 0, 68, 27],
  ],
  oranges: [
    [0, 255, 245, 235],
    [0.125, 254, 230, 206],
    [0.25, 253, 208, 162],
    [0.375, 253, 174, 107],
    [0.5, 253, 141, 60],
    [0.625, 241, 105, 19],
    [0.75, 217, 72, 1],
    [0.875, 166, 54, 3],
    [1, 127, 39, 4],
  ],
  reds: [
    [0, 255, 245, 240],
    [0.125, 254, 224, 210],
    [0.25, 252, 187, 161],
    [0.375, 252, 146, 114],
    [0.5, 251, 106, 74],
    [0.625, 239, 59, 44],
    [0.75, 203, 24, 29],
    [0.875, 165, 15, 21],
    [1, 103, 0, 13],
  ],
  ylorbr: [
    [0, 255, 255, 229],
    [0.125, 255, 247, 188],
    [0.25, 254, 227, 145],
    [0.375, 254, 196, 79],
    [0.5, 254, 153, 41],
    [0.625, 236, 112, 20],
    [0.75, 204, 76, 2],
    [0.875, 153, 52, 4],
    [1, 102, 37, 6],
  ],
  ylorrd: [
    [0, 255, 255, 204],
    [0.25, 254, 217, 118],
    [0.375, 254, 178, 76],
    [0.5, 253, 141, 60],
    [0.625, 252, 78, 42],
    [0.75, 227, 26, 28],
    [0.875, 189, 0, 38],
    [1, 128, 0, 38],
  ],
  orrd: [
    [0, 255, 247, 236],
    [0.125, 254, 232, 200],
    [0.25, 253, 212, 158],
    [0.375, 253, 187, 132],
    [0.5, 252, 141, 89],
    [0.625, 239, 101, 72],
    [0.75, 215, 48, 31],
    [0.875, 179, 0, 0],
    [1, 127, 0, 0],
  ],
  purd: [
    [0, 247, 244, 249],
    [0.125, 231, 225, 239],
    [0.25, 212, 185, 218],
    [0.375, 201, 148, 199],
    [0.5, 223, 101, 176],
    [0.625, 231, 41, 138],
    [0.75, 206, 18, 86],
    [0.875, 152, 0, 67],
    [1, 103, 0, 31],
  ],
  rdpu: [
    [0, 255, 247, 243],
    [0.125, 253, 224, 221],
    [0.25, 252, 197, 192],
    [0.375, 250, 159, 181],
    [0.5, 247, 104, 161],
    [0.625, 221, 52, 151],
    [0.75, 174, 1, 126],
    [0.875, 122, 1, 119],
    [1, 73, 0, 106],
  ],
  bupu: [
    [0, 247, 252, 253],
    [0.125, 224, 236, 244],
    [0.375, 158, 188, 218],
    [0.5, 140, 150, 198],
    [0.625, 140, 107, 177],
    [0.75, 136, 65, 157],
    [0.875, 129, 15, 124],
    [1, 77, 0, 75],
  ],
  gnbu: [
    [0, 247, 252, 240],
    [0.25, 204, 235, 197],
    [0.375, 168, 221, 181],
    [0.5, 123, 204, 196],
    [0.625, 78, 179, 211],
    [0.875, 8, 104, 172],
    [1, 8, 64, 129],
  ],
  pubu: [
    [0, 255, 247, 251],
    [0.125, 236, 231, 242],
    [0.25, 208, 209, 230],
    [0.375, 166, 189, 219],
    [0.5, 116, 169, 207],
    [0.625, 54, 144, 192],
    [0.75, 5, 112, 176],
    [0.875, 4, 90, 141],
    [1, 2, 56, 88],
  ],
  ylgnbu: [
    [0, 255, 255, 217],
    [0.125, 237, 248, 177],
    [0.25, 199, 233, 180],
    [0.375, 127, 205, 187],
    [0.5, 65, 182, 196],
    [0.625, 29, 145, 192],
    [0.75, 34, 94, 168],
    [0.875, 37, 52, 148],
    [1, 8, 29, 88],
  ],
  pubugn: [
    [0, 255, 247, 251],
    [0.125, 236, 226, 240],
    [0.25, 208, 209, 230],
    [0.375, 166, 189, 219],
    [0.5, 103, 169, 207],
    [0.625, 54, 144, 192],
    [0.75, 2, 129, 138],
    [0.875, 1, 108, 89],
    [1, 1, 70, 54],
  ],
  bugn: [
    [0, 247, 252, 253],
    [0.125, 229, 245, 249],
    [0.25, 204, 236, 230],
    [0.375, 153, 216, 201],
    [0.5, 102, 194, 164],
    [0.625, 65, 174, 118],
    [0.75, 35, 139, 69],
    [0.875, 0, 109, 44],
    [1, 0, 68, 27],
  ],
  ylgn: [
    [0, 255, 255, 229],
    [0.125, 247, 252, 185],
    [0.25, 217, 240, 163],
    [0.375, 173, 221, 142],
    [0.5, 120, 198, 121],
    [0.625, 65, 171, 93],
    [0.75, 35, 132, 67],
    [0.875, 0, 104, 55],
    [1, 0, 69, 41],
  ],
  binary: [
    [0, 255, 255, 255],
    [1, 0, 0, 0],
  ],
  gist_yarg: [
    [0, 255, 255, 255],
    [1, 1, 1, 1],
  ],
  gist_gray: [
    [0, 0, 0, 0],
    [1, 254, 254, 254],
  ],
  gray: [
    [0, 0, 0, 0],
    [1, 255, 255, 255],
  ],
  bone: [
    [0, 0, 0, 0],
    [0.365079, 81, 81, 113],
    [0.746032, 166, 198, 198],
    [1, 255, 255, 255],
  ],
  pink: [
    [0, 30, 0, 0],
    [0.015873, 50, 26, 26],
    [0.047619, 75, 45, 45],
    [0.095238, 102, 64, 64],
    [0.174603, 136, 87, 87],
    [0.301587, 176, 114, 114],
    [0.365079, 194, 126, 126],
    [0.460317, 204, 159, 141],
    [0.587302, 217, 195, 160],
    [0.746032, 232, 232, 180],
    [0.904762, 247, 247, 230],
    [1, 255, 255, 255],
  ],
  spring: [
    [0, 255, 0, 255],
    [1, 255, 255, 0],
  ],
  summer: [
    [0, 0, 128, 102],
    [1, 255, 255, 102],
  ],
  autumn: [
    [0, 255, 0, 0],
    [1, 255, 255, 0],
  ],
  winter: [
    [0, 0, 0, 255],
    [1, 0, 255, 128],
  ],
  cool: [
    [0, 0, 255, 255],
    [1, 255, 0, 255],
  ],
  hot: [
    [0, 11, 0, 0],
    [0.365079, 255, 0, 0],
    [0.746032, 255, 255, 0],
    [1, 255, 255, 255],
  ],
  afmhot: [
    [0, 0, 0, 0],
    [0.251969, 128, 0, 0],
    [0.496063, 252, 125, 0],
    [0.511811, 255, 134, 7],
    [0.748031, 255, 254, 127],
    [1, 255, 255, 255],
  ],
  gist_heat: [
    [0, 0, 0, 0],
    [0.210084, 76, 0, 0],
    [0.252101, 92, 0, 0],
    [0.294118, 108, 0, 0],
    [0.37395, 136, 0, 0],
    [0.428571, 156, 0, 0],
    [0.478992, 175, 1, 0],
    [0.5, 182, 11, 0],
    [0.508403, 186, 17, 0],
    [0.62605, 228, 71, 0],
    [0.642857, 236, 81, 0],
    [0.701681, 255, 107, 0],
    [0.726891, 255, 120, 0],
    [0.752101, 255, 132, 0],
    [0.760504, 255, 137, 11],
    [0.794118, 255, 153, 43],
    [0.798319, 255, 156, 51],
    [0.878151, 255, 192, 125],
    [0.882353, 255, 196, 133],
    [0.962185, 255, 232, 207],
    [0.966387, 255, 236, 215],
    [1, 255, 251, 247],
  ],
  copper: [
    [0, 0, 0, 0],
    [0.809524, 255, 161, 103],
    [1, 255, 199, 127],
  ],
  piyg: [
    [0, 142, 1, 82],
    [0.1, 197, 27, 125],
    [0.2, 222, 119, 174],
    [0.3, 241, 182, 218],
    [0.4, 253, 224, 239],
    [0.5, 247, 247, 247],
    [0.6, 230, 245, 208],
    [0.7, 184, 225, 134],
    [0.8, 127, 188, 65],
    [0.9, 77, 146, 33],
    [1, 39, 100, 25],
  ],
  prgn: [
    [0, 64, 0, 75],
    [0.1, 118, 42, 131],
    [0.2, 153, 112, 171],
    [0.3, 194, 165, 207],
    [0.4, 231, 212, 232],
    [0.5, 247, 247, 247],
    [0.6, 217, 240, 211],
    [0.7, 166, 219, 160],
    [0.8, 90, 174, 97],
    [0.9, 27, 120, 55],
    [1, 0, 68, 27],
  ],
  brbg: [
    [0, 84, 48, 5],
    [0.1, 140, 81, 10],
    [0.2, 191, 129, 45],
    [0.3, 223, 194, 125],
    [0.4, 246, 232, 195],
    [0.5, 245, 245, 245],
    [0.6, 199, 234, 229],
    [0.7, 128, 205, 193],
    [0.8, 53, 151, 143],
    [0.9, 1, 102, 94],
    [1, 0, 60, 48],
  ],
  puor: [
    [0, 127, 59, 8],
    [0.1, 179, 88, 6],
    [0.2, 224, 130, 20],
    [0.3, 253, 184, 99],
    [0.4, 254, 224, 182],
    [0.5, 247, 247, 247],
    [0.6, 216, 218, 235],
    [0.7, 178, 171, 210],
    [0.8, 128, 115, 172],
    [0.9, 84, 39, 136],
    [1, 45, 0, 75],
  ],
  rdgy: [
    [0, 103, 0, 31],
    [0.1, 178, 24, 43],
    [0.2, 214, 96, 77],
    [0.3, 244, 165, 130],
    [0.4, 253, 219, 199],
    [0.5, 255, 255, 255],
    [0.6, 224, 224, 224],
    [0.7, 186, 186, 186],
    [0.8, 135, 135, 135],
    [0.9, 77, 77, 77],
    [1, 26, 26, 26],
  ],
  rdbu: [
    [0, 103, 0, 31],
    [0.1, 178, 24, 43],
    [0.2, 214, 96, 77],
    [0.3, 244, 165, 130],
    [0.4, 253, 219, 199],
    [0.5, 247, 247, 247],
    [0.6, 209, 229, 240],
    [0.7, 146, 197, 222],
    [0.8, 67, 147, 195],
    [0.9, 33, 102, 172],
    [1, 5, 48, 97],
  ],
  rdylbu: [
    [0, 165, 0, 38],
    [0.1, 215, 48, 39],
    [0.2, 244, 109, 67],
    [0.3, 253, 174, 97],
    [0.4, 254, 224, 144],
    [0.5, 255, 255, 191],
    [0.6, 224, 243, 248],
    [0.7, 171, 217, 233],
    [0.8, 116, 173, 209],
    [0.9, 69, 117, 180],
    [1, 49, 54, 149],
  ],
  rdylgn: [
    [0, 165, 0, 38],
    [0.1, 215, 48, 39],
    [0.2, 244, 109, 67],
    [0.3, 253, 174, 97],
    [0.4, 254, 224, 139],
    [0.5, 255, 255, 191],
    [0.6, 217, 239, 139],
    [0.7, 166, 217, 106],
    [0.8, 102, 189, 99],
    [0.9, 26, 152, 80],
    [1, 0, 104, 55],
  ],
  spectral: [
    [0, 158, 1, 66],
    [0.1, 213, 62, 79],
    [0.2, 244, 109, 67],
    [0.3, 253, 174, 97],
    [0.4, 254, 224, 139],
    [0.5, 255, 255, 191],
    [0.6, 230, 245, 152],
    [0.7, 171, 221, 164],
    [0.8, 102, 194, 165],
    [0.9, 50, 136, 189],
    [1, 94, 79, 162],
  ],
  coolwarm: [
    [0, 59, 76, 192],
    [0.09375, 87, 117, 225],
    [0.15625, 108, 142, 241],
    [0.21875, 130, 165, 251],
    [0.28125, 152, 185, 255],
    [0.34375, 174, 201, 253],
    [0.40625, 194, 213, 244],
    [0.46875, 213, 219, 230],
    [0.5, 221, 221, 221],
    [0.5625, 236, 211, 197],
    [0.625, 245, 196, 173],
    [0.71875, 247, 166, 135],
    [0.8125, 236, 127, 99],
    [0.90625, 213, 80, 66],
    [0.9375, 203, 62, 56],
    [0.96875, 192, 40, 47],
    [1, 180, 4, 38],
  ],
  bwr: [
    [0, 0, 0, 255],
    [0.5, 255, 255, 255],
    [1, 255, 0, 0],
  ],
  seismic: [
    [0, 0, 0, 76],
    [0.25, 0, 0, 255],
    [0.5, 255, 255, 255],
    [0.75, 255, 0, 0],
    [1, 128, 0, 0],
  ],
  hsv: [
    [0, 255, 0, 0],
    [0.15873, 255, 239, 0],
    [0.174603, 247, 255, 0],
    [0.333333, 8, 255, 0],
    [0.349206, 0, 255, 16],
    [0.507937, 0, 255, 255],
    [0.666667, 0, 16, 255],
    [0.68254, 8, 0, 255],
    [0.84127, 247, 0, 255],
    [0.857143, 255, 0, 239],
    [1, 255, 0, 24],
  ],
  pastel1: [
    [0, 251, 180, 174],
    [0.111111, 251, 180, 174],
    [0.111111, 179, 205, 227],
    [0.222222, 179, 205, 227],
    [0.222222, 204, 235, 197],
    [0.333333, 204, 235, 197],
    [0.333333, 222, 203, 228],
    [0.444444, 222, 203, 228],
    [0.444444, 254, 217, 166],
    [0.555556, 254, 217, 166],
    [0.555556, 255, 255, 204],
    [0.666667, 255, 255, 204],
    [0.666667, 229, 216, 189],
    [0.777778, 229, 216, 189],
    [0.777778, 253, 218, 236],
    [0.888889, 253, 218, 236],
    [0.888889, 242, 242, 242],
    [1, 242, 242, 242],
  ],
  pastel2: [
    [0, 179, 226, 205],
    [0.125, 179, 226, 205],
    [0.125, 253, 205, 172],
    [0.25, 253, 205, 172],
    [0.25, 203, 213, 232],
    [0.375, 203, 213, 232],
    [0.375, 244, 202, 228],
    [0.5, 244, 202, 228],
    [0.5, 230, 245, 201],
    [0.625, 230, 245, 201],
    [0.625, 255, 242, 174],
    [0.75, 255, 242, 174],
    [0.75, 241, 226, 204],
    [0.875, 241, 226, 204],
    [0.875, 204, 204, 204],
    [1, 204, 204, 204],
  ],
  paired: [
    [0, 166, 206, 227],
    [0.083333, 166, 206, 227],
    [0.083333, 31, 120, 180],
    [0.166667, 31, 120, 180],
    [0.166667, 178, 223, 138],
    [0.25, 178, 223, 138],
    [0.25, 51, 160, 44],
    [0.333333, 51, 160, 44],
    [0.333333, 251, 154, 153],
    [0.416667, 251, 154, 153],
    [0.416667, 227, 26, 28],
    [0.5, 227, 26, 28],
    [0.5, 253, 191, 111],
    [0.583333, 253, 191, 111],
    [0.583333, 255, 127, 0],
    [0.666667, 255, 127, 0],
    [0.666667, 202, 178, 214],
    [0.75, 202, 178, 214],
    [0.75, 106, 61, 154],
    [0.833333, 106, 61, 154],
    [0.833333, 255, 255, 153],
    [0.916667, 255, 255, 153],
    [0.916667, 177, 89, 40],
    [1, 177, 89, 40],
  ],
  accent: [
    [0, 127, 201, 127],
    [0.125, 127, 201, 127],
    [0.125, 190, 174, 212],
    [0.25, 190, 174, 212],
    [0.25, 253, 192, 134],
    [0.375, 253, 192, 134],
    [0.375, 255, 255, 153],
    [0.5, 255, 255, 153],
    [0.5, 56, 108, 176],
    [0.625, 56, 108, 176],
    [0.625, 240, 2, 127],
    [0.75, 240, 2, 127],
    [0.75, 191, 91, 23],
    [0.875, 191, 91, 23],
    [0.875, 102, 102, 102],
    [1, 102, 102, 102],
  ],
  dark2: [
    [0, 27, 158, 119],
    [0.125, 27, 158, 119],
    [0.125, 217, 95, 2],
    [0.25, 217, 95, 2],
    [0.25, 117, 112, 179],
    [0.375, 117, 112, 179],
    [0.375, 231, 41, 138],
    [0.5, 231, 41, 138],
    [0.5, 102, 166, 30],
    [0.625, 102, 166, 30],
    [0.625, 230, 171, 2],
    [0.75, 230, 171, 2],
    [0.75, 166, 118, 29],
    [0.875, 166, 118, 29],
    [0.875, 102, 102, 102],
    [1, 102, 102, 102],
  ],
  set1: [
    [0, 228, 26, 28],
    [0.111111, 228, 26, 28],
    [0.111111, 55, 126, 184],
    [0.222222, 55, 126, 184],
    [0.222222, 77, 175, 74],
    [0.333333, 77, 175, 74],
    [0.333333, 152, 78, 163],
    [0.444444, 152, 78, 163],
    [0.444444, 255, 127, 0],
    [0.555556, 255, 127, 0],
    [0.555556, 255, 255, 51],
    [0.666667, 255, 255, 51],
    [0.666667, 166, 86, 40],
    [0.777778, 166, 86, 40],
    [0.777778, 247, 129, 191],
    [0.888889, 247, 129, 191],
    [0.888889, 153, 153, 153],
    [1, 153, 153, 153],
  ],
  set2: [
    [0, 102, 194, 165],
    [0.125, 102, 194, 165],
    [0.125, 252, 141, 98],
    [0.25, 252, 141, 98],
    [0.25, 141, 160, 203],
    [0.375, 141, 160, 203],
    [0.375, 231, 138, 195],
    [0.5, 231, 138, 195],
    [0.5, 166, 216, 84],
    [0.625, 166, 216, 84],
    [0.625, 255, 217, 47],
    [0.75, 255, 217, 47],
    [0.75, 229, 196, 148],
    [0.875, 229, 196, 148],
    [0.875, 179, 179, 179],
    [1, 179, 179, 179],
  ],
  set3: [
    [0, 141, 211, 199],
    [0.083333, 141, 211, 199],
    [0.083333, 255, 255, 179],
    [0.166667, 255, 255, 179],
    [0.166667, 190, 186, 218],
    [0.25, 190, 186, 218],
    [0.25, 251, 128, 114],
    [0.333333, 251, 128, 114],
    [0.333333, 128, 177, 211],
    [0.416667, 128, 177, 211],
    [0.416667, 253, 180, 98],
    [0.5, 253, 180, 98],
    [0.5, 179, 222, 105],
    [0.583333, 179, 222, 105],
    [0.583333, 252, 205, 229],
    [0.666667, 252, 205, 229],
    [0.666667, 217, 217, 217],
    [0.75, 217, 217, 217],
    [0.75, 188, 128, 189],
    [0.833333, 188, 128, 189],
    [0.833333, 204, 235, 197],
    [0.916667, 204, 235, 197],
    [0.916667, 255, 237, 111],
    [1, 255, 237, 111],
  ],
  flag: [
    [0, 255, 0, 0],
    [0.015873, 255, 255, 255],
    [0.031746, 0, 0, 255],
    [0.047619, 0, 0, 0],
    [0.063492, 255, 0, 0],
    [0.079365, 255, 255, 255],
    [0.095238, 0, 0, 255],
    [0.111111, 0, 0, 0],
    [0.126984, 255, 0, 0],
    [0.142857, 255, 255, 255],
    [0.15873, 0, 0, 255],
    [0.174603, 0, 0, 0],
    [0.190476, 255, 0, 0],
    [0.206349, 255, 255, 255],
    [0.222222, 0, 0, 255],
    [0.238095, 0, 0, 0],
    [0.253968, 255, 0, 0],
    [0.269841, 255, 255, 255],
    [0.285714, 0, 0, 255],
    [0.301587, 0, 0, 0],
    [0.31746, 255, 0, 0],
    [0.333333, 255, 255, 255],
    [0.349206, 0, 0, 255],
    [0.365079, 0, 0, 0],
    [0.380952, 255, 0, 0],
    [0.396825, 255, 255, 255],
    [0.412698, 0, 0, 255],
    [0.428571, 0, 0, 0],
    [0.444444, 255, 0, 0],
    [0.460317, 255, 255, 255],
    [0.47619, 0, 0, 255],
    [0.492063, 0, 0, 0],
    [0.507937, 255, 0, 0],
    [0.52381, 255, 255, 255],
    [0.539683, 0, 0, 255],
    [0.555556, 0, 0, 0],
    [0.571429, 255, 0, 0],
    [0.587302, 255, 255, 255],
    [0.603175, 0, 0, 255],
    [0.619048, 0, 0, 0],
    [0.634921, 255, 0, 0],
    [0.650794, 255, 255, 255],
    [0.666667, 0, 0, 255],
    [0.68254, 0, 0, 0],
    [0.698413, 255, 0, 0],
    [0.714286, 255, 255, 255],
    [0.730159, 0, 0, 255],
    [0.746032, 0, 0, 0],
    [0.761905, 255, 0, 0],
    [0.777778, 255, 255, 255],
    [0.793651, 0, 0, 255],
    [0.809524, 0, 0, 0],
    [0.825397, 255, 0, 0],
    [0.84127, 255, 255, 255],
    [0.857143, 0, 0, 255],
    [0.873016, 0, 0, 0],
    [0.888889, 255, 0, 0],
    [0.904762, 255, 255, 255],
    [0.920635, 0, 0, 255],
    [0.936508, 0, 0, 0],
    [0.952381, 255, 0, 0],
    [0.968254, 255, 255, 255],
    [0.984127, 0, 0, 255],
    [1, 0, 0, 0],
  ],
  prism: [
    [0, 255, 0, 0],
    [0.031746, 255, 255, 0],
    [0.047619, 0, 255, 0],
    [0.063492, 0, 0, 255],
    [0.079365, 170, 0, 255],
    [0.095238, 255, 0, 0],
    [0.126984, 255, 255, 0],
    [0.142857, 0, 255, 0],
    [0.15873, 0, 0, 255],
    [0.174603, 170, 0, 255],
    [0.190476, 255, 0, 0],
    [0.222222, 255, 255, 0],
    [0.238095, 0, 255, 0],
    [0.253968, 0, 0, 255],
    [0.269841, 170, 0, 255],
    [0.285714, 255, 0, 0],
    [0.31746, 255, 255, 0],
    [0.333333, 0, 255, 0],
    [0.349206, 0, 0, 255],
    [0.365079, 170, 0, 255],
    [0.380952, 255, 0, 0],
    [0.412698, 255, 255, 0],
    [0.428571, 0, 255, 0],
    [0.444444, 0, 0, 255],
    [0.460317, 170, 0, 255],
    [0.47619, 255, 0, 0],
    [0.507937, 255, 255, 0],
    [0.52381, 0, 255, 0],
    [0.539683, 0, 0, 255],
    [0.555556, 170, 0, 255],
    [0.571429, 255, 0, 0],
    [0.603175, 255, 255, 0],
    [0.619048, 0, 255, 0],
    [0.634921, 0, 0, 255],
    [0.650794, 170, 0, 255],
    [0.666667, 255, 0, 0],
    [0.698413, 255, 255, 0],
    [0.714286, 0, 255, 0],
    [0.730159, 0, 0, 255],
    [0.746032, 170, 0, 255],
    [0.761905, 255, 0, 0],
    [0.793651, 255, 255, 0],
    [0.809524, 0, 255, 0],
    [0.825397, 0, 0, 255],
    [0.84127, 170, 0, 255],
    [0.857143, 255, 0, 0],
    [0.888889, 255, 255, 0],
    [0.904762, 0, 255, 0],
    [0.920635, 0, 0, 255],
    [0.936508, 170, 0, 255],
    [0.952381, 255, 0, 0],
    [0.984127, 255, 255, 0],
    [1, 0, 255, 0],
  ],
  gist_earth: [
    [0, 0, 0, 0],
    [0.004202, 0, 0, 46],
    [0.029412, 0, 0, 116],
    [0.12605, 17, 57, 120],
    [0.210084, 33, 99, 124],
    [0.281513, 48, 128, 128],
    [0.462185, 70, 155, 71],
    [0.487395, 83, 158, 73],
    [0.55042, 121, 168, 82],
    [0.697479, 183, 183, 94],
    [0.785714, 192, 163, 101],
    [0.836134, 207, 171, 131],
    [0.886555, 221, 185, 165],
    [0.94958, 239, 215, 211],
    [1, 253, 251, 251],
  ],
  gist_stern: [
    [0, 0, 0, 0],
    [0.037815, 163, 9, 17],
    [0.042017, 199, 11, 21],
    [0.054622, 254, 14, 27],
    [0.121849, 172, 30, 59],
    [0.12605, 161, 32, 63],
    [0.205882, 63, 51, 101],
    [0.210084, 52, 53, 105],
    [0.247899, 6, 62, 123],
    [0.252101, 64, 64, 127],
    [0.289916, 73, 73, 145],
    [0.306723, 78, 78, 155],
    [0.37395, 94, 94, 187],
    [0.386555, 98, 98, 195],
    [0.457983, 115, 115, 229],
    [0.47479, 120, 120, 239],
    [0.5, 126, 126, 251],
    [0.504202, 128, 128, 255],
    [0.542017, 137, 137, 217],
    [0.55042, 140, 140, 204],
    [0.62605, 158, 158, 128],
    [0.630252, 160, 160, 119],
    [0.710084, 179, 179, 39],
    [0.714286, 181, 181, 30],
    [0.743697, 188, 188, 0],
    [0.752101, 190, 190, 7],
    [0.756303, 192, 192, 15],
    [0.794118, 201, 201, 49],
    [0.798319, 203, 203, 57],
    [0.878151, 222, 222, 129],
    [0.882353, 224, 224, 137],
    [0.962185, 243, 243, 209],
    [0.970588, 246, 246, 220],
    [1, 253, 253, 247],
  ],
  gnuplot2: [
    [0, 0, 0, 0],
    [0.251969, 1, 0, 255],
    [0.417323, 132, 0, 255],
    [0.448819, 157, 14, 241],
    [0.496063, 195, 38, 217],
    [0.503937, 204, 44, 211],
    [0.566929, 254, 76, 179],
    [0.913386, 255, 252, 3],
    [0.92126, 255, 255, 5],
    [1, 255, 255, 255],
  ],
  cmrmap: [
    [0, 0, 0, 0],
    [0.125984, 38, 38, 128],
    [0.251969, 77, 38, 191],
    [0.377953, 154, 51, 126],
    [0.496063, 250, 63, 42],
    [0.503937, 254, 67, 36],
    [0.622047, 230, 127, 0],
    [0.748031, 230, 191, 25],
    [0.874016, 230, 229, 127],
    [1, 255, 255, 255],
  ],
  gist_rainbow: [
    [0, 255, 0, 42],
    [0.029412, 255, 0, 4],
    [0.033613, 255, 5, 0],
    [0.092437, 255, 81, 0],
    [0.096639, 255, 91, 0],
    [0.155462, 255, 167, 0],
    [0.159664, 255, 178, 0],
    [0.218487, 255, 253, 0],
    [0.222689, 245, 255, 0],
    [0.281513, 170, 255, 0],
    [0.285714, 159, 255, 0],
    [0.344538, 84, 255, 0],
    [0.34874, 73, 255, 0],
    [0.403361, 3, 255, 0],
    [0.407563, 0, 255, 1],
    [0.411765, 0, 255, 12],
    [0.470588, 0, 255, 87],
    [0.47479, 0, 255, 98],
    [0.533613, 0, 255, 173],
    [0.537815, 0, 255, 184],
    [0.592437, 0, 255, 254],
    [0.596639, 0, 250, 255],
    [0.60084, 0, 239, 255],
    [0.659664, 0, 164, 255],
    [0.663866, 0, 153, 255],
    [0.722689, 0, 78, 255],
    [0.726891, 0, 67, 255],
    [0.777311, 0, 2, 255],
    [0.781513, 2, 0, 255],
    [0.785714, 7, 0, 255],
    [0.789916, 18, 0, 255],
    [0.84874, 93, 0, 255],
    [0.852941, 104, 0, 255],
    [0.911765, 180, 0, 255],
    [0.915966, 190, 0, 255],
    [0.966387, 255, 0, 254],
    [0.97479, 255, 0, 243],
    [0.978992, 255, 0, 233],
    [1, 255, 0, 206],
  ],
  rainbow: [
    [0, 128, 0, 255],
    [0.11811, 68, 92, 251],
    [0.19685, 28, 147, 243],
    [0.251969, 0, 181, 235],
    [0.314961, 32, 213, 225],
    [0.377953, 64, 236, 212],
    [0.433071, 93, 249, 199],
    [0.496063, 125, 255, 182],
    [0.535433, 146, 253, 169],
    [0.598425, 178, 243, 150],
    [0.661417, 210, 222, 129],
    [0.724409, 242, 194, 107],
    [0.748031, 254, 181, 98],
    [0.84252, 255, 121, 62],
    [0.984252, 255, 13, 6],
    [1, 255, 0, 0],
  ],
  jet: [
    [0, 0, 0, 128],
    [0.11, 0, 0, 255],
    [0.125, 0, 0, 255],
    [0.34, 0, 219, 255],
    [0.35, 0, 229, 247],
    [0.375, 21, 255, 226],
    [0.64, 239, 255, 8],
    [0.65, 247, 246, 0],
    [0.66, 255, 236, 0],
    [0.89, 255, 19, 0],
    [0.91, 232, 0, 0],
    [1, 128, 0, 0],
  ],
  turbo: [
    [0, 48, 18, 59],
    [0.031496, 57, 42, 115],
    [0.062992, 64, 64, 162],
    [0.094488, 68, 86, 199],
    [0.125984, 70, 107, 227],
    [0.15748, 70, 128, 246],
    [0.181102, 68, 143, 254],
    [0.204724, 61, 158, 254],
    [0.23622, 47, 178, 244],
    [0.283465, 28, 205, 216],
    [0.314961, 24, 221, 194],
    [0.330709, 25, 227, 185],
    [0.354331, 34, 235, 170],
    [0.385827, 56, 244, 145],
    [0.440945, 109, 254, 98],
    [0.480315, 146, 255, 71],
    [0.503937, 167, 252, 58],
    [0.535433, 188, 245, 52],
    [0.582677, 217, 228, 54],
    [0.629921, 239, 205, 58],
    [0.669291, 251, 184, 56],
    [0.716535, 254, 153, 44],
    [0.771654, 247, 111, 26],
    [0.818898, 234, 78, 13],
    [0.874016, 210, 49, 5],
    [0.929134, 178, 26, 1],
    [0.984252, 136, 8, 2],
    [1, 122, 4, 3],
  ],
  gist_ncar: [
    [0, 0, 0, 128],
    [0.050505, 0, 95, 5],
    [0.055556, 0, 94, 12],
    [0.106061, 0, 0, 255],
    [0.156566, 0, 183, 255],
    [0.161616, 0, 194, 255],
    [0.207071, 0, 249, 255],
    [0.212121, 0, 254, 253],
    [0.262626, 0, 250, 157],
    [0.282828, 0, 251, 100],
    [0.313131, 0, 254, 12],
    [0.318182, 1, 254, 0],
    [0.368687, 98, 206, 0],
    [0.378788, 106, 213, 0],
    [0.424242, 128, 255, 1],
    [0.474747, 190, 255, 60],
    [0.479798, 196, 255, 57],
    [0.525253, 250, 255, 4],
    [0.530303, 255, 253, 0],
    [0.585859, 255, 212, 1],
    [0.631313, 255, 186, 14],
    [0.636364, 255, 181, 14],
    [0.686869, 255, 70, 0],
    [0.737374, 255, 4, 0],
    [0.742424, 255, 0, 8],
    [0.792929, 255, 0, 252],
    [0.80303, 236, 8, 255],
    [0.843434, 160, 45, 255],
    [0.848485, 158, 51, 254],
    [0.89899, 237, 129, 238],
    [0.964646, 247, 205, 247],
    [1, 254, 248, 254],
  ],
};

/** Ordered colormap names (lowercase, PlotPy keys). */
export const COLORMAP_NAMES: readonly string[] = [
  "viridis",
  "plasma",
  "inferno",
  "magma",
  "cividis",
  "greys",
  "purples",
  "blues",
  "greens",
  "oranges",
  "reds",
  "ylorbr",
  "ylorrd",
  "orrd",
  "purd",
  "rdpu",
  "bupu",
  "gnbu",
  "pubu",
  "ylgnbu",
  "pubugn",
  "bugn",
  "ylgn",
  "binary",
  "gist_yarg",
  "gist_gray",
  "gray",
  "bone",
  "pink",
  "spring",
  "summer",
  "autumn",
  "winter",
  "cool",
  "hot",
  "afmhot",
  "gist_heat",
  "copper",
  "piyg",
  "prgn",
  "brbg",
  "puor",
  "rdgy",
  "rdbu",
  "rdylbu",
  "rdylgn",
  "spectral",
  "coolwarm",
  "bwr",
  "seismic",
  "hsv",
  "pastel1",
  "pastel2",
  "paired",
  "accent",
  "dark2",
  "set1",
  "set2",
  "set3",
  "flag",
  "prism",
  "gist_earth",
  "gist_stern",
  "gnuplot2",
  "cmrmap",
  "gist_rainbow",
  "rainbow",
  "jet",
  "turbo",
  "gist_ncar",
];

/** Colormap names grouped by category, for the UI selector. */
export const COLORMAP_CATEGORIES: readonly {
  readonly label: string;
  readonly names: readonly string[];
}[] = [
  {
    label: "Perceptually uniform",
    names: ["viridis", "plasma", "inferno", "magma", "cividis"],
  },
  {
    label: "Sequential",
    names: [
      "greys",
      "purples",
      "blues",
      "greens",
      "oranges",
      "reds",
      "ylorbr",
      "ylorrd",
      "orrd",
      "purd",
      "rdpu",
      "bupu",
      "gnbu",
      "pubu",
      "ylgnbu",
      "pubugn",
      "bugn",
      "ylgn",
      "binary",
      "gist_yarg",
      "gist_gray",
      "gray",
      "bone",
      "pink",
      "spring",
      "summer",
      "autumn",
      "winter",
      "cool",
      "hot",
      "afmhot",
      "gist_heat",
      "copper",
    ],
  },
  {
    label: "Diverging",
    names: [
      "piyg",
      "prgn",
      "brbg",
      "puor",
      "rdgy",
      "rdbu",
      "rdylbu",
      "rdylgn",
      "spectral",
      "coolwarm",
      "bwr",
      "seismic",
    ],
  },
  { label: "Cyclic", names: ["hsv"] },
  {
    label: "Qualitative",
    names: [
      "pastel1",
      "pastel2",
      "paired",
      "accent",
      "dark2",
      "set1",
      "set2",
      "set3",
    ],
  },
  {
    label: "Miscellaneous",
    names: [
      "flag",
      "prism",
      "gist_earth",
      "gist_stern",
      "gnuplot2",
      "cmrmap",
      "gist_rainbow",
      "rainbow",
      "jet",
      "turbo",
      "gist_ncar",
    ],
  },
];
